<script setup>
    useHead({
        title: (() => 'FAQ')(),
    })
</script>

<template>
    <div class="faq-listing container">
        <FaqListing />
    </div>
</template>
